/* EcomverX COD Center — pixel base code (auto-generated; managed from the panel). */
(function () {
  'use strict';
  var FB_IDS = ["982156560607437"];
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  for (var i = 0; i < FB_IDS.length; i++) {
    try {
      var st = typeof window.fbq.getState === 'function' ? window.fbq.getState() : null;
      var inited = !!(st && st.pixels && st.pixels.some(function (p) { return String(p.id) === FB_IDS[i]; }));
      if (!inited) window.fbq('init', FB_IDS[i]);
      window.fbq('trackSingle', FB_IDS[i], 'PageView');
    } catch (e) { /* never break the storefront */ }
  }
})();
